import {IHostingCertificatesState} from "../reducers/hosting-certificates.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCertificatesHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingCertificates);

export const getCertificates = (websiteId: number) => createSelector(getCertificatesHostingState,
  (state: IHostingCertificatesState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);


export const getCertificatesMap = (websiteId: number) => createSelector(getCertificatesHostingState,
  (state: IHostingCertificatesState) =>
    state.entities[websiteId]
);


export const getCertificatesLoading = (websiteId: number) => createSelector(getCertificatesHostingState,
  (state: IHostingCertificatesState) =>
    state.entities[websiteId].loading
);

export const getCertificatesLoaded = (websiteId: number) => createSelector(getCertificatesHostingState,
  (state: IHostingCertificatesState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
